export const platformAdminCommon = {
  open: "開く",
  openPortal: "ポータルを開く",
  openExamAdmin: "試験管理を開く",
  consolePage: "管理画面",
  modulePage: "関連モジュール",
  detail: "状態詳細",
  endpoint: "エンドポイント URL",
  phase: "フェーズ",
  statusCodeLatency: "HTTP {status} ・ {latency} ms",
  probeStatusCode: "プローブ HTTP 状態",
  probeLatency: "プローブ遅延",
  checkedAt: "最終確認時刻",
  latestError: "直近エラー",
  latestCheckSuccess: "直近の確認ではエラーは見つかりませんでした。",
  probeErrors: {
    urlUnavailable: "ヘルスチェック URL が利用できません",
    httpError: "プローブが HTTP {status} を返しました",
    timeout: "プローブが {timeout_ms} ms でタイムアウトしました",
    requestAborted: "プローブ要求が中断されました",
    networkUnreachable: "プローブが対象サービスに到達できませんでした",
    requestFailed: "プローブ要求に失敗しました",
  },
  planning: "計画中",
  pageNotFound: "ページが見つかりません。",
  backToAdmin: "プラットフォーム管理へ戻る",
  domainLabel: "ドメイン: {value}",
  latencyLabel: "遅延: {value}",
} as const;
